import { Box } from "@mui/material"
import { useMemo } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getLegislationLinkHealth } from "./controller/get-legislation-link-health"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { withComparison } from "lib/graphql/comparison-function"
import { isSame } from "library/normalized-stringify/index.mjs"
import { isLegislationHealthConcerning } from "./lib/legislation-health-utils.mjs"

export function AuthoringGuidanceTitle() {
    const { target } = useBoundContext()
    const legislation = target?.legislation

    const ids = useMemo(extractIds, [legislation])
    const healthResults = getLegislationLinkHealth.useResults(
        { ids },
        withInitialValue([]),
        withComparison((left, right) => isSame(left, right, { invalidChars: [] }))
    )

    const badgeContent = useMemo(countAttentionNeeded, [healthResults])

    return (
        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
            <Box component="span">References</Box>
            <Box
                component="span"
                sx={{
                    display: badgeContent ? "inline-flex" : "none",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 20,
                    height: 20,
                    px: 0.5,
                    borderRadius: 999,
                    bgcolor: "warning.main",
                    color: "warning.contrastText",
                    fontSize: 12,
                    fontWeight: 700,
                    lineHeight: 1,
                }}
            >
                {badgeContent}
            </Box>
        </Box>
    )

    function extractIds() {
        return (Array.isArray(legislation) ? legislation : []).map(String).filter(Boolean)
    }

    function countAttentionNeeded() {
        if (!Array.isArray(healthResults)) return 0
        return healthResults.filter(isLegislationHealthConcerning).length
    }
}
